import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const reliquidationEmployeesRequest = ({
  dispatch,
  params = {},
  successCallback,
  callback,
  service = 'payroll'
}) => {
  ApiService.request('get', '/reliquidations/employees', {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });
};

export const deleteReliquidationRequest = (
  id,
  { dispatch, params = {}, successCallback, callback, service = 'payroll' }
) => {
  ApiService.request('delete', `/reliquidations/${id}`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });
};

export const downloadReliquidationRequest = (
  id,
  { dispatch, params = {}, successCallback, callback, service = 'payroll' }
) => {
  ApiService.request('get', `/reliquidations/${id}/download`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });
};

export const massiveDeleteReliquidationRequest = ({
  dispatch,
  params = {},
  successCallback,
  callback,
  service = 'payroll'
}) => {
  ApiService.request('delete', '/reliquidations/massive_destroy', {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });
};

export const reliquidationDetailExportRequest = (
  id,
  { dispatch, params = {}, successCallback, callback, service = 'payroll' }
) =>
  ApiService.request('get', `/reliquidations/${id}/details_export.xlsx`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const reliquidationSummaryExportRequest = (
  id,
  { dispatch, params = {}, successCallback, callback, service = 'payroll' }
) =>
  ApiService.request('get', `/reliquidations/${id}/summary_export.xlsx`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const debounceReliquidationEmployeesRequest = AwesomeDebouncePromise(reliquidationEmployeesRequest, 500);
